import { Button, DialogActions } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const SendTestDialogButtons: FC<{
  setSaving: (value: boolean) => void;
  setTestDialog: (value: boolean) => void;
  publishing: boolean;
  isSubmitting: boolean;
}> = ({ setSaving, setTestDialog, publishing, isSubmitting }) => {
  const { t } = useTranslation();
  return (
    <DialogActions>
      <Button
        data-analytics-id="moment-form-send-test-dialog-cancel"
        onClick={() => {
          setTestDialog(false);
          setSaving(false);
        }}
        disabled={publishing}
      >
        {t("Cancel")}
      </Button>
      <Button
        data-analytics-id="moment-form-send-test-dialog-send"
        type="submit"
        loading={isSubmitting}
        variant="contained"
      >
        {t("Send Test")}
      </Button>
    </DialogActions>
  );
};
